import { GetModelsParams, GetModelsResponse, Model } from './model.type';
import { ConversationService } from '../conversation/conversation.service';

export const ModelService = {
  getModels: async (_params?: GetModelsParams): Promise<GetModelsResponse> => {
    try {
      const supportedModels = await ConversationService.listSupportedModel();

      // Map API response to Model type
      const models: Model[] = supportedModels.map((supportedModel) => {
        // Extract provider from model_name or use a default
        // You can adjust this logic based on your needs
        let provider = 'Unknown';
        if (supportedModel.model_name.toLowerCase().includes('gpt')) {
          provider = 'OpenAI';
        } else if (supportedModel.model_name.toLowerCase().includes('gemini')) {
          provider = 'Google';
        } else if (supportedModel.model_name.toLowerCase().includes('grok')) {
          provider = 'xAI';
        }

        return {
          id: supportedModel.model_name, // Use model_name as id
          name: supportedModel.model_name, // model_name for API requests
          model_name: supportedModel.model_name, // Keep original model_name
          display_name: supportedModel.display_name, // display_name for UI
          provider: provider,
          isActive: true,
          description: supportedModel.description,
          url_icon: supportedModel.url_icon,
          // Default to true when the API omits the flag (back-compat with the old format).
          support: supportedModel.support ?? true,
        };
      });

      return {
        data: models,
      };
    } catch (error) {
      console.error('Failed to fetch supported models:', error);
      // Return empty array on error
      return {
        data: [],
      };
    }
  },
};
